import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2d6d415f&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=2d6d415f&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=2d6d415f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d415f",
  null
  
)

export default component.exports